export const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=ai.yellowdots.app'
export const IOS_APP_URL = 'https://apps.apple.com/in/app/yellowdots-ai/id6827887148'
